import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';

import SweetAlert from 'react-bootstrap-sweetalert';
import { Badge } from 'reactstrap';
import { Th, Thead, Tr } from 'react-super-responsive-table';

import { getDmxUniversesByController, deleteDmxUniverse, toggleDmxUniverseStatus } from '../../store/actions';

class DmxUniverseList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      universeList: null,
      universeToDelete: null,
      showConfirm: false,
      popup: false,
      pop_msg: '',
      alertType: '',
    };
  }

  componentDidMount() {
    this.props.getDmxUniversesByController(this.state.user, this.props.controllerId);
  }

  componentDidUpdate(prevProps) {
    if (this.props.universes !== prevProps.universes) {
      this.setState({ universeList: this.props.universes });
    }
    if (this.props.loadingDeleteDmxUniverse === false && prevProps.loadingDeleteDmxUniverse === true) {
      this.props.getDmxUniversesByController(this.state.user, this.props.controllerId);
      if (this.props.deleteDmxUniverseError) {
        this.setState({
          popup: true,
          pop_msg: this.props.deleteDmxUniverseError.message || 'Error al eliminar el universo',
          alertType: 'error',
        });
      }
    }
    if (this.props.loadingToggleDmxUniverseStatus === false && prevProps.loadingToggleDmxUniverseStatus === true) {
      this.props.getDmxUniversesByController(this.state.user, this.props.controllerId);
      if (this.props.toggleDmxUniverseStatusError) {
        this.setState({
          popup: true,
          pop_msg: this.props.toggleDmxUniverseStatusError.message || 'Error al cambiar el estado del universo',
          alertType: 'error',
        });
      }
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
  }

  confirmDelete(universe) {
    this.setState({ showConfirm: true, universeToDelete: universe });
  }

  doDelete() {
    const { user, universeToDelete } = this.state;
    this.props.deleteDmxUniverse({
      id: universeToDelete.id,
      controller_id: this.props.controllerId,
      token: user.token,
    });
    this.setState({ showConfirm: false });
  }

  toggleStatus(universe) {
    const { user } = this.state;
    this.props.toggleDmxUniverseStatus({
      id: universe.id,
      active: !(Number(universe.active) === 1),
      token: user.token,
    });
  }

  render() {
    const { universeList } = this.state;
    if (!universeList) return null;
    return (
      <div className="table-responsive mt-3">
        <table className="table table-centered table-nowrap mb-0">
          <Thead>
            <Tr>
              <Th>{this.props.t('Universo')}</Th>
              <Th>{this.props.t('Canales')}</Th>
              <Th>{this.props.t('Estado')}</Th>
              <Th>{this.props.t('Actions')}</Th>
            </Tr>
          </Thead>
          <tbody>
            {universeList.map((u) => (
              <tr key={u.id}>
                <td>{u.universe_number}</td>
                <td>{u.channel_count}</td>
                <td>
                  <Badge color={Number(u.active) === 1 ? 'success' : 'secondary'} pill>
                    {this.props.t(Number(u.active) === 1 ? 'Activo' : 'Inactivo')}
                  </Badge>
                </td>
                <td>
                  <button
                    className="btn btn-primary waves-effect waves-light buttonStatus txtField"
                    title="Ocupación"
                    onClick={() => this.props.history.push(`/dmxUniverseOccupancy/${u.id}`)}
                  >
                    <i className="mdi mdi-view-list font-size-14 align-middle"></i>
                  </button>
                  <button
                    className={`btn ${Number(u.active) === 1 ? 'btn-secondary' : 'btn-success'} waves-effect waves-light buttonStatus txtField`}
                    title={Number(u.active) === 1 ? 'Desactivar' : 'Activar'}
                    onClick={() => this.toggleStatus(u)}
                  >
                    <i className="mdi mdi-power font-size-14" style={{ verticalAlign: 'middle' }}></i>
                  </button>
                  <button
                    className="btn btn-danger waves-effect waves-light buttonStatus txtField"
                    title="Eliminar"
                    onClick={() => this.confirmDelete(u)}
                  >
                    <i className="far fa-trash-alt font-size-14 align-middle"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {this.state.showConfirm ? (
          <SweetAlert
            showCancel
            title="¿Estás seguro?"
            cancelBtnBsStyle="danger"
            confirmBtnBsStyle="success"
            confirmBtnText={this.props.t('ok')}
            cancelBtnText={this.props.t('Cancel')}
            onConfirm={() => this.doDelete()}
            onCancel={() => this.setState({ showConfirm: false })}
          >
            {this.props.t('Solo se puede borrar un universo sin dispositivos asociados')}
          </SweetAlert>
        ) : null}
        {this.state.popup ? (
          <SweetAlert
            type={this.state.alertType === 'correct' ? 'success' : 'error'}
            confirmBtnBsStyle={this.state.alertType === 'correct' ? 'success' : 'danger'}
            title={this.state.pop_msg}
            confirmBtnText={this.props.t('ok')}
            onConfirm={() => this.confirmPopup()}
          ></SweetAlert>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { universes } = state.getDmxUniversesByController;
  const { loadingDeleteDmxUniverse, deleteDmxUniverseError } = state.deleteDmxUniverse;
  const { loadingToggleDmxUniverseStatus, toggleDmxUniverseStatusError } = state.toggleDmxUniverseStatus;
  return {
    universes,
    loadingDeleteDmxUniverse,
    deleteDmxUniverseError,
    loadingToggleDmxUniverseStatus,
    toggleDmxUniverseStatusError,
  };
};

export default withRouter(
  connect(mapStateToProps, { getDmxUniversesByController, deleteDmxUniverse, toggleDmxUniverseStatus })(
    withNamespaces()(DmxUniverseList),
  ),
);
